import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// constants
import { getHeaderArticles, getProductStatus } from '../../../constants';

const ArticlesHeader = ({ articles_texts = {} }) => {
  const { t } = useTranslation(['backoffice']);
  const header = getHeaderArticles(t)

  return (
    <>
      {Object.keys(articles_texts).length > 0 ? header.map(({ size, key }) => (
        <Col md={size}>
          <label className='span-details'>{['ean', 'title', 'editorial'].includes(key) ?
            articles_texts['product'][key] :
            key === 'estado' ? getProductStatus(t)[articles_texts[key]].value :
              articles_texts[key]}</label>
        </Col>
      )) : header.map(({ size, name }) => (
        <Col md={size}>
          <label>{name}</label>
        </Col>
      ))}
      {!articles_texts && <Col md={1}>
        <label>{t('delete')}</label>
      </Col>}
    </>
  );
};

ArticlesHeader.propTypes = {
  articles_texts: PropTypes.object
};
export default ArticlesHeader;
